import React from "react";
import { shape, string } from "prop-types";
import { Redirect } from "@magento/venia-drivers";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./formSubmissionSuccessful.css";
var FormSubmissionSuccessful = props => {
  var {
    email
  } = props;
  var classes = mergeClasses(defaultClasses, props.classes);
  var textMessage = "If there is an account associated with ".concat(email, " you will receive an email with a link to change your password.");
  return /*#__PURE__*/React.createElement(Redirect, {
    to: "/login-feedback#pwdchanged-step1"
  });
};
export default FormSubmissionSuccessful;
FormSubmissionSuccessful.propTypes = {
  classes: shape({
    root: string,
    text: string
  }),
  email: string
};